import React, { useEffect } from 'react'
import useLogin from '../hooks/useLogin';
// import Store from 'electron-store'

const UserState = () => {
    const { getSession } = useLogin()


    useEffect(()=>{
        getSession()
    },[])
    return (
        <></>
    )
}

export default UserState